module.exports = __webpack_public_path__ + "img/telephone.fd1acc14.png";